import {
  withTranslation,
} from 'react-i18next';

import RaceInfoButtonView from './RaceInfoButtonView';

const TranslatedComponent = withTranslation()(RaceInfoButtonView);

const Component = TranslatedComponent;

export default Component;
